/**
 * @fileOverview
 * 移动光标到指定块
 *
 * @see https://github.com/draft-js-plugins/draft-js-plugins/blob/master/draft-js-focus-plugin/src/modifiers/setSelection.js
 */

import { SelectionState, EditorState } from 'draft-js';
import DraftOffsetKey from 'draft-js/lib/DraftOffsetKey';

/**
 * Set selection of editor to next/previous block
 *
 * @param {DraftEditorStore} store
 * @param {Draft.ContentBlock} block
 * @param {"collapse"|"expand"} type
 */
export function setSelectionToBlock(store, block, type) {
	const { getEditorState, setEditorState } = store;

	// TODO verify that always a key-0-0 exists
	const offsetKey = DraftOffsetKey.encode(block.getKey(), 0, 0);
	const node = document.querySelectorAll(`[data-offset-key="${offsetKey}"]`)[0];

	// 之前以为 forceSelection 会帮你处理原生光标，发现太 naive 了，需要自己来处理。原注释：
	// set the native selection to the node so the caret is not in the text and
	// the selectionState matches the native selection
	const selection = window.getSelection();
	const range = document.createRange();
	range.setStart(node, 0);
	range.setEnd(node, 0);
	selection.removeAllRanges();
	selection.addRange(range);

	const offset = type === 'expand' ? block.getLength() : 0;
	setEditorState(EditorState.forceSelection(getEditorState(), new SelectionState({
		anchorKey: block.getKey(),
		anchorOffset: offset,
		focusKey: block.getKey(),
		focusOffset: offset,
		isBackward: false,
	})));
};



// WEBPACK FOOTER //
// ./lib/helpers/setSelectionToBlock.js